
































































import BaseComponent from '@/components/base-component.vue';
import UiCnpjFormat from '@/components/UI/cnpj-format.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { UnidadesFilterDTO } from '@/interfaces/clientUnit';
import * as service from '@/services/client-unit-report';
import { STATUS_LIST_VALUE_LABEL } from '@/settings/consts/commons';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    UiSelectClients,
    UiCnpjFormat,
  },
})
export default class ClientUnitReport extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  public loadingXls: boolean = false;

  public filter: any = {
    term: '',
    client: null,
    status: null,
  };

  public statusList: any[] = STATUS_LIST_VALUE_LABEL;

  public headers: any = [
    { text: 'Razão Social', value: 'razaoSocial', sortable: true },
    { text: 'Nome Fantasia', value: 'nomeFantasia', sortable: true },
    { text: 'Unidade', value: 'unidade', sortable: true },
    { text: 'CNPJ', value: 'cnpj', sortable: true },
    { text: 'Status', value: 'status', sortable: true },
    { text: 'Cód-Lj Protheus', value: 'codigoProtheus', sortable: true },
    { text: 'Possui aprovacao de prescrição', value: 'possuiAprovacao', sortable: true },
    { text: 'Bolsa Multicompartimentada', value: 'bolsaMulticomp', sortable: true },
    { text: 'Agendamento Produção', value: 'agendamentoProducao', sortable: true },
    { text: 'Horário envio produção', value: 'horaAgendamentoProducao', sortable: true },
    { text: 'Envio Whatsapp Pendência Prescrição (minutos)', value: 'pendenciaPrescWhatsappAutoMinutos', sortable: true },
    { text: 'Whatsapp - Tolerância envio após prazo (minutos)', value: 'pendenciaPrescWhatsappTolerPrazo', sortable: true },
    { text: 'Utiliza campo observação', value: 'usaCampoObs', sortable: true },
  ];
  public data: any[] = [];
  public pagination: PaginationSyncDTO = new PaginationSyncDTO();

  public beforeMount(): void {
    this.load();
  }

  public onFilter(): void {
    this.load();
  }

  private load(): void {
    this.data = [];
    this.loading = true;

    service.getClientUnitsDataReport(this.buildFilters()).subscribe(
      (data) => {
        this.data = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  private buildFilters() {
    let filters = new UnidadesFilterDTO();
    filters.ativo = this.filter.status;
    filters.idCliente = this.filter.client ? this.filter.client.id : null;
    filters.termos = this.filter.term ? this.filter.term : null;

    return filters;
  }

  public exportXls() {
    this.loadingXls = true;
    let filters = this.buildFilters();
    service.buildClientUnitsXlsReport(filters).subscribe(
      (r) => {
        this.forceFileAxiosResponseDownload(r, 'unidades.xls');
        this.loadingXls = false;
      },
      (error) => {
        this.loadingXls = false;
        this.showToastApiError(error);
      },
    );
  }
}
